/* tslint:disable */

/**
 */
export class Transaction {
    amount?: number;
    activated?: string;
    ticket_number?: string;
}
